import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n/config'
// import { registerSW } from 'virtual:pwa-register'
import { UPDATE_AVAILABLE_EVENT } from './constants/events'

// Force unregister old Service Workers to fix blank screen issues in production
const unregisterOldServiceWorkers = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        console.log('Unregistering old service worker...');
        await registration.unregister();
      }
      // Clear all caches
      const cacheNames = await caches.keys();
      for (const cacheName of cacheNames) {
        console.log('Deleting cache:', cacheName);
        await caches.delete(cacheName);
      }
    } catch (error) {
      console.error('Error cleaning up service workers:', error);
    }
  }
};

// CRITICAL: Detect password recovery BEFORE React mounts
// This prevents race conditions on mobile where auth redirects happen before components mount
const detectPasswordRecoveryEarly = () => {
  const hashParams = new URLSearchParams(window.location.hash.substring(1));
  const type = hashParams.get('type');
  const accessToken = hashParams.get('access_token');
  
  if (type === 'recovery' && accessToken) {
    console.log('Early detection: Password recovery tokens found, setting flag');
    sessionStorage.setItem('password_reset_in_progress', 'true');
    
    // If we're not on the reset-password page, redirect there
    if (!window.location.pathname.includes('/reset-password')) {
      console.log('Early detection: Redirecting to reset-password page');
      window.location.href = '/reset-password' + window.location.hash;
    }
  }
};

// Run detection immediately
detectPasswordRecoveryEarly();

// Temporarily disabled: Clean up old service workers to diagnose blank screen
// if ('serviceWorker' in navigator) {
//   unregisterOldServiceWorkers().then(() => {
//     registerSW({
//       onNeedRefresh() {
//         window.dispatchEvent(new CustomEvent(UPDATE_AVAILABLE_EVENT));
//       },
//       onOfflineReady() {
//         console.log('App ready to work offline')
//       },
//     });
//   });
// }

// Still unregister old service workers on load
if ('serviceWorker' in navigator) {
  unregisterOldServiceWorkers();
}

createRoot(document.getElementById("root")!).render(<App />);
